import { toLowerCase } from "@/helpers/string.helpers"

export const createSearchParamFromTag = (tag: string) => toLowerCase(tag)
